// extracted by mini-css-extract-plugin
export var activityContainer = "_js-0";
export var typingIndicatorContainer = "_js-1";
export var typingIndicatorDot = "_js-2";
export var wave = "_js-3";